import React, {useMemo} from 'react';
import {Requirement} from 'types';
import {FullTextSearchRequirementsQuery} from '../../hooks';
import {SearchResultRequirement} from '../SearchCards/SearchResultCards';
import {getEntityListColumns, SearchResult} from './SearchResult';
import {useRequirementsPageColumn} from 'features/Requirements/RequirementsPageColumns';
import {RequirementsTooltipTranslationProvider} from 'features/Requirements/RequirementsTooltipTranslationProvider';
import {useTranslation} from 'react-i18next';

const entityName = 'Requirements';

const primitiveColumns: string[] = ['requirementId', 'status'];
const arrayColumns: string[] = [
	'vexClusters',
	'systemLevels',
	'markets',
	'keywords',
];
const dateColumns: string[] = [];
const omitColumns: string[] = [
	'attachments',
	'regulations',
	'regulatoryDocuments',
	'references',
	'FAQ',
	'tags',
];
const quickFilterColumns: string[] = arrayColumns;

type RequirmentSearchResultProps = {
	currentViewKey: string;
	isResultCardFormat: boolean;
	loading: boolean;
	requirementData: FullTextSearchRequirementsQuery | undefined;
};

export const RequirmentSearchResult: React.FC<
	RequirmentSearchResultProps
> = props => {
	const columnsInfinity = useRequirementsPageColumn();
	const {t: tEnum} = useTranslation('common/enums');

	const propsResult = useMemo(() => {
		const columns = getEntityListColumns(
			columnsInfinity,
			primitiveColumns,
			arrayColumns,
			dateColumns,
			omitColumns,
		).map(x => {
			if (x.key === 'status') {
				return {
					...x,
					getFilterKey: (x: any) => x,
					getFilterLabel: (value: any) => tEnum(`RequirementStatus.${value}`),
				};
			}
			return x;
		});

		const searchedItems =
			props.requirementData?.searchRequirements.requirements ?? [];

		const renderCard = (item: Requirement) => (
			<SearchResultRequirement key={item.id} item={item} />
		);

		const renderEntityList = (EntityList: JSX.Element) => {
			return (
				<RequirementsTooltipTranslationProvider>
					{EntityList}
				</RequirementsTooltipTranslationProvider>
			);
		};

		return {
			...props,
			entityName,
			searchedItems,
			columns,
			quickFilterColumns,
			renderCard,
			renderEntityList,
		};
	}, [props]);

	return <SearchResult {...propsResult} />;
};
